import React from 'react'
import UserListCard from '@/components/UserListCard'

export default function OrganizationUsers() {
    return <UserListCard />
}
